import React from 'react';
import Button from 'v3/components/Button';

function summary({ mode, selection, continued }) {
  const { vehicle, wagons, driver } = selection;
  const plates = [vehicle, ...wagons]
    .filter(Boolean)
    .map((a) => a.plate)
    .join(' / ');
  // 5720: só pelo implemento (5719), sem cavalo nem motorista; os dois vêm do cadastro.
  const crew = !vehicle
    ? 'sem cavalo: informe o cavalo e o motorista no cadastro'
    : driver
      ? driver.name || 'Motorista selecionado'
      : 'sem motorista: informe o motorista no cadastro';
  // 5724: na carga que veio da pré-carga completada, o aceite já foi registrado.
  const acceptance = continued
    ? 'O aceite foi registrado ao completar a pré-carga.'
    : 'O aceite será registrado ao salvar com sucesso.';
  return `${mode === 'OTHER' ? 'Atendimento com outro veículo' : 'Atendimento pelo Kanban'}: ${plates} · ${crew}. ${acceptance}`;
}

/** Mensagens extras (children) ficam dentro do quadro, que tem fundo claro sobre a faixa do cabeçalho. */
export default function AttendanceNotice({ attendance, busy = false, children }) {
  const { record, error, back, accessPending } = attendance;
  if (!record && !error && !accessPending) return null;
  return (
    <div
      className="tc-attendance-notice"
      role={error ? 'alert' : 'status'}
      style={{
        padding: 16,
        marginBottom: 16,
        background: '#edf6f5',
        border: '1px solid #badbd6',
        borderRadius: 6,
      }}
    >
      <p style={{ marginBottom: 8 }}>
        {error || (accessPending ? 'Confirmando acesso ao atendimento…' : summary(record))}
      </p>
      {children}
      <Button variant="secondary" size="sm" disabled={busy} onClick={back}>
        Cancelar e voltar ao Kanban
      </Button>
    </div>
  );
}
